
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import GetOrganizationResponse from "@/types/Organization/GetOrganizationResponse";
import DataObject from "@/types/DataObject";
import {
  WorkshopFilter,
  WorkshopFilterTypes
} from "@/types/Workshop/WorkshopList/WorkshopFilter";
import EducatorAuxData from "@/types/Educator/EducatorAuxData";
import VMSAutoComplete from "@/components/fields/VMSAutoComplete.vue";
import EducatorAuxDataDataSource from "@/types/Pocos/AutoCompleteDataSources/EducatorAuxDataDataSource";
import VolunteerDataSource, {
  VolunteerLookupItem
} from "@/types/Pocos/AutoCompleteDataSources/VolunteerDataSource";
import OrganizationDataSource from "@/types/Pocos/AutoCompleteDataSources/OrganizationDataSource";

@Component({
  components: {
    VMSAutoComplete
  }
})
export default class WorkshopListFilter extends Vue {
  @Prop(Array) value!: WorkshopFilter[];

  menu_open: boolean = false;
  filters: WorkshopFilter[] = this.value || [];

  filterVolunteer: VolunteerLookupItem | null = null;
  filterSchoolId: string | null = null;
  schoolDictionary: DataObject = new DataObject();
  volunteerDictionary: DataObject = new DataObject();
  educatorDictionary: DataObject = new DataObject();

  filterEducator: EducatorAuxData | null = null;

  educator_data_source: EducatorAuxDataDataSource = new EducatorAuxDataDataSource();
  volunteer_data_source: VolunteerDataSource = new VolunteerDataSource();
  org_data_source: OrganizationDataSource = new OrganizationDataSource();

  onVolunteerFilterApplied() {
    if (this.filterVolunteer) {
      let fn: string = this.filterVolunteer.SubjectName;
      let val: object = {
        SubjectId: this.filterVolunteer.SubjectId,
        SiteId: this.filterVolunteer.SiteId
      };
      this.filters.push(
        new WorkshopFilter(WorkshopFilterTypes.Volunteer, val, fn)
      );

      this.onInput();
    }
  }

  onSchoolSelected(org: GetOrganizationResponse) {
    console.log(org);
    if (!this.schoolDictionary[org.Id]) {
      this.schoolDictionary[org.Id] = org;
    }
  }

  onEducatorFilterApplied() {
    if (this.filterEducator) {
      let en: string = "";
      if (this.filterEducator.FirstName && this.filterEducator.LastName)
        en = this.filterEducator.FirstName.concat(
          " ",
          this.filterEducator.LastName
        );

      this.filters.push(
        new WorkshopFilter(
          WorkshopFilterTypes.Educator,
          this.filterEducator.Id,
          en
        )
      );

      this.onInput();
    }
  }

  onSchoolFilterApplied() {
    if (this.filterSchoolId) {
      this.filters.push(
        new WorkshopFilter(
          WorkshopFilterTypes.School,
          this.filterSchoolId,
          this.schoolDictionary[this.filterSchoolId].Name
        )
      );

      (this.$refs.school_autocomplete as VMSAutoComplete).Clear();
      this.onInput();
    }
  }

  onInput() {
    this.menu_open = false;
    this.$emit("input", this.filters);
  }
}
